import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";

const categories = {
  state: {
    categories: [],
    category: null,
    show: false,
  },
  mutations: {
    setCategories(state, val) {
      state.categories = val;
    },
    setCategory(state, val) {
      state.category = val;
    },
    setCategoryShow(state, val) {
      state.show = val;
    },
  },
  actions: {
    async suggestCategories({ commit, dispatch, rootState }) {
      commit("setLoading", { type: "categories", val: true });
      const suggestCategories = httpsCallable(functions, "suggestCategories");
      const res = await suggestCategories({
        first_time: true,
        workspace: rootState.workspace.workspace.uid,
      });
      console.log(JSON.parse(res.data).categories);
      dispatch("fetchCategories");
      commit("setLoading", { type: "categories", val: false });
    },
  },
  getters: {},
};

export default categories;
